// Canonical spacing scale (4-pt rhythm). Mobile screens historically size
// against a 393-pt design width (see portfolioHomeUnit in
// packages/mobile/src/features/portfolio-home/tokens.ts); these steps are the
// design-unit values both platforms compose from.
export const Spacing = {
  xs: 4,
  sm: 8,
  md: 12,
  lg: 16,
  xl: 20,
  "2xl": 24,
  "3xl": 32,
  "4xl": 40,
  "5xl": 48,
} as const;

export type T_SpacingToken = keyof typeof Spacing;

/** Reference design width (pt) mobile scales against. */
export const DESIGN_WIDTH = 393;
